var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentsFolderBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 28,
    fill: "none",
    viewBox: "0 0 36 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9DD3FF",
    d: "M9.014 0c.4856 0 .8796.4324.8798.9688l2.3311 2.497 14.4902.0098c1.3156.1467 2.3408 1.3679 2.3408 2.8574v17.9072c0 1.5842-1.5094 2.872-2.6074 2.8721H2.8157C1.378 27.1122.2102 25.8249.2102 24.2402V5.9238c0-.0072.001-.0143.001-.0215V.9688C.2114.4324.6052 0 1.0892 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EAEED",
    d: "M4.3109 26.334c-1.455 0-3.0302-1.2203-3.5212-2.7313L.9258 7.1695c.0902-1.0859.8729-2.7319 2.3302-2.7319h22.6131c1.4527 0 3.0305 1.2247 3.5202 2.7319l-.1373 16.4332c-.2583 1.0545-.873 2.7313-2.328 2.7313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EAEED",
    d: "M4.6251 26.4492c-1.44 0-3.003-1.2202-3.4939-2.7313l.0795-16.4332c.0856-1.0858.8546-2.7318 2.2969-2.7318h22.3792c1.4377 0 3.0032 1.2246 3.493 2.7318l-.0806 16.4332c-.2522 1.0546-.8549 2.7313-2.2948 2.7313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5EAEED",
    d: "M4.9959 25.5273c-1.4548 0-3.0297-1.2202-3.5207-2.7312l.129-14.5872c.0901-1.0858.8725-2.7318 2.3296-2.7318h22.6091c1.4524 0 3.03 1.2246 3.5197 2.7318l-.1301 14.5872c-.2583 1.0545-.8727 2.7312-2.3275 2.7312"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE8FF",
    d: "M5.2594 25.7246c-1.44 0-3.003-1.2202-3.494-2.7313L1.845 8.4062c.0857-1.0858.8547-2.7319 2.297-2.7319H26.521c1.4376 0 3.0032 1.2247 3.4929 2.7319l-.0806 14.5871c-.2521 1.0546-.8548 2.7313-2.2948 2.7313"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCE8FF",
    d: "M5.8316 23.9961c-1.44 0-3.003-1.2203-3.494-2.7313l.0795-12.1256c.0857-1.0859.8547-2.7319 2.297-2.7319h22.3792c1.4376 0 2.7774 1.2246 3.2671 2.7319l-.0806 12.1256c-.2521 1.0545-.629 2.7313-2.069 2.7313"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5F3FF",
    d: "M6.0404 24.0937c-1.44 0-3.003-1.2202-3.494-2.7312L2.626 9.2368c.0856-1.0858.8546-2.7318 2.2969-2.7318H27.302c1.4377 0 2.7775 1.2246 3.2672 2.7318l-.0806 12.1257c-.2522 1.0545-.6291 2.7312-2.069 2.7312"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3DDFF",
    d: "M31.0234 8.621c1.4399 0 2.6064 1.2831 2.6064 2.8719l-4.0193 12.7497c-.4384 1.1417-1.7423 2.8724-3.1845 2.8724H2.816c-1.4376 0-2.6053-1.2876-2.6053-2.8724l4.0205-12.7497c.5948-1.1088 1.7422-2.8718 3.1822-2.8718"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentsFolderBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/documents-folder-blue.e65a6d5a1695d3bae524b465a6aa4366.svg";